import React, { Component } from 'react'
import { connect } from 'react-redux';
import Checkbox from './checkbox'
import icon_team_leader from '../../../assets/img/icon-team-leader.svg';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { faEllipsisV, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DEFAULT_SESSION_ID } from '../../../core/constants';
import { teamsMembersListActions, getCurrentTeamMembersList } from '../../../core/teams-members-list'
import { teamsReportListActions, getTeamsReportById } from '../../../core/teams-report'
import { List } from 'immutable';


import { teamActions } from '../../../core/teams'
import LoadingIndicator from '../loading-indicator';

class MemberItem extends Component {

  constructor(props) {
    super(props)

    this.state = {
      show_modal: false
    }

    this.handleModal = this.handleModal.bind(this);

  }

  handleModal = (e, confirm) => {
    const { show_modal } = this.state;
    const { member, loadTeamsReport, team_id } = this.props;
    if (confirm && show_modal) {
      this.handleActionMember({ section: 'remove-member', member_id: member.id })
      loadTeamsReport(team_id);
    }

    this.setState({ show_modal: !show_modal })
  }

  handleActionMember({ section = '', member_id = null }) {
    const { setLeaderTeamMember, removeTeamMember, team_id } = this.props
    if (section === 'set-member-leader') {
      setLeaderTeamMember(team_id, member_id)

      if(this.props.onChangeLeaderMember) {
        this.props.onChangeLeaderMember(member_id);
      }
    }
    if (section === 'remove-member') {
      removeTeamMember(team_id, member_id)
    }
  }

  render() {
    const { member, isMember, handleCheckboxChange, members_selected, isLeader, displayLoadingIndicator } = this.props
    const { show_modal } = this.state

    return (
      <>
        <div className="member-item d-flex align-items-center border rounded-lg p-2">
          {!isMember ? <div className="text-center">
            <Checkbox handleCheckboxChange={handleCheckboxChange} select_option={members_selected} label="" value={member.id} /></div> : ''
          }

          <div className="d-flex align-items-center text-reset text-decoration-none flex-fill">
            <div className="pr-2">
              <img width="32" height="32" src={member.avatar} alt={member.first_name} />
            </div>
            <div className="pr-2 w-100">
              <p className="h6 mb-1 text-truncate text-nowrap">
                {(member.first_name) ? `${member.first_name} ${member.last_name}` : member.username}
                {(isMember && (isLeader === 1)) ? <img className="talents-icon-arrow ml-2" src={icon_team_leader} width="16" height="auto" alt="Team Leader" /> : null}
              </p>
              <p className="small text-muted line-height-normal mb-0">{member.seniority ? member.seniority.name : ''}</p>
            </div>
          </div>

          {isMember &&
            <div className="ml-auto group-edit position-relative">
              <UncontrolledDropdown direction={'left'}>
                <DropdownToggle color='link' className='btn-sm border-0 text-reset'>
                  <FontAwesomeIcon size='sm' icon={faEllipsisV} className='mx-1' />
                </DropdownToggle>
                <DropdownMenu style={{ minWidth: '136px', marginRight: '10px' }}>
                  {(isLeader === 1) &&
                    <DropdownItem className='px-0' tag={'div'}>
                      <Button color='link' className='text-reset px-3 text-decoration-none' onClick={(e) => { e.preventDefault(); this.handleActionMember({ section: 'set-member-leader', member_id: member.id }) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" className='mr-2' fill='currentColor'>
                          <path d="M8.2,4.4l-2.7,6c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0H1.8c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1
                        c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.2-2.4L1.4,4.8C1.3,4.7,1.3,4.6,1.3,4.5c0-0.1,0-0.2,0.1-0.3
                        c0-0.1,0.1-0.1,0.2-0.1C1.6,4,1.7,4,1.8,4H8c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1S8.3,4.3,8.2,4.4z M14.8,2.6
                        c-0.1-0.1-0.2-0.1-0.4-0.1h-4c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.1-0.2,0.2L7.4,8.6c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
                        c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0h3.6L9,13.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.2,0.1
                        c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.2l5-11C15,3.1,15,3,15,2.9C15,2.8,14.9,2.7,14.8,2.6
                        z"/>
                        </svg> Remove as Team Leader
                      </Button>
                    </DropdownItem>
                  }
                  {(isLeader === 0) &&
                    <DropdownItem className='px-0' tag={'div'}>
                      <Button color='link' className='text-reset px-3 text-decoration-none' onClick={(e) => { e.preventDefault(); this.handleActionMember({ section: 'set-member-leader', member_id: member.id }) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" className='mr-2' fill='currentColor'>
                          <path d="M8.2,4.4l-2.7,6c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0H1.8c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1
                      c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.2-2.4L1.4,4.8C1.3,4.7,1.3,4.6,1.3,4.5c0-0.1,0-0.2,0.1-0.3
                      c0-0.1,0.1-0.1,0.2-0.1C1.6,4,1.7,4,1.8,4H8c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1S8.3,4.3,8.2,4.4z M14.8,2.6
                      c-0.1-0.1-0.2-0.1-0.4-0.1h-4c-0.1,0-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.1-0.2,0.2L7.4,8.6c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1
                      c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0h3.6L9,13.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0.1,0.1,0.2,0.1
                      c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.2l5-11C15,3.1,15,3,15,2.9C15,2.8,14.9,2.7,14.8,2.6
                      z"/>
                        </svg> Set as Team Leader
                      </Button>
                    </DropdownItem>
                  }
                  <DropdownItem className='p-0' tag={'div'} >
                    <Button color='link' className='text-danger px-3 text-decoration-none' onClick={(e) => { e.preventDefault(); this.handleModal() }}>
                      <FontAwesomeIcon icon={faTimesCircle} className='mr-2' />
                      Remove From Team
                    </Button>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          }
        </div>
        {displayLoadingIndicator && <LoadingIndicator />}

        {isMember &&
          <Modal isOpen={show_modal} toggle={this.handleModal} className="pop-up-confirm">
            <ModalHeader close={<></>} toggle={this.handleModalDelete} className='justify-content-center border-0 pb-0' cssModule={{ 'modal-title': 'modal-title libre-caslon-text-regular h4 mt-3' }}>Remove member</ModalHeader>
            <ModalBody className='pt-3'>
              <p className='h5 font-weight-normal mb-4 text-center'>Are you sure you want to Remove "{member.first_name} {member.last_name}"</p>
              <div className="d-flex justify-content-center">
                <Button color="green-light" size="sm" className="mx-3 text-nowrap" onClick={(e) => this.handleModal(e, true)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill="currentColor" className='mr-2'>
                    <path d="M12.3,3.1h-2V2.5c0-0.4-0.2-0.8-0.4-1.1C9.6,1.1,9.2,0.9,8.8,0.9H6.2c-0.4,0-0.8,0.2-1.1,0.4
                C4.8,1.7,4.7,2.1,4.7,2.5v0.7h-2c-0.2,0-0.3,0.1-0.5,0.2S2,3.6,2,3.8s0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h0.2v7.4
                c0,0.3,0.1,0.6,0.3,0.8C3.4,12.9,3.7,13,4,13h7c0.3,0,0.6-0.1,0.8-0.3s0.3-0.5,0.3-0.8V4.4h0.2c0.2,0,0.3-0.1,0.5-0.2
                C12.9,4.1,13,4,13,3.8s-0.1-0.3-0.2-0.5C12.7,3.2,12.5,3.1,12.3,3.1z M6,2.5C6,2.4,6,2.4,6,2.3c0,0,0.1-0.1,0.2-0.1h2.6
                c0.1,0,0.1,0,0.2,0.1C9,2.4,9,2.4,9,2.5v0.7H6V2.5z M10.8,11.7H4.2V4.4h6.6V11.7z M6.8,6.2v3.5c0,0.2-0.1,0.3-0.2,0.5
                c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2C5.6,10,5.5,9.9,5.5,9.7V6.2c0-0.2,0.1-0.3,0.2-0.5C5.8,5.6,6,5.5,6.2,5.5
                s0.3,0.1,0.5,0.2C6.8,5.8,6.8,6,6.8,6.2z M9.5,6.2v3.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2
                C8.2,10,8.2,9.9,8.2,9.7V6.2c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2s0.3,0.1,0.5,0.2C9.4,5.8,9.5,6,9.5,6.2z"/>
                  </svg>
                  <span className="h6 font-weight-normal text-reset align-middle">Yes, Remove</span>
                </Button>
                <Button color="outline-green-light" size="sm" className="mx-3 text-nowrap" onClick={this.handleModal}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill='currentColor' className='mr-2'>
                    <path d="M11.9,11c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                  L7.5,8.4L4,11.9c-0.1,0.1-0.3,0.2-0.5,0.2S3.2,12,3.1,11.9c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5l3.5-3.5L3.1,4
                  C3,3.9,2.9,3.7,2.9,3.6S3,3.2,3.1,3.1C3.2,3,3.4,2.9,3.6,2.9S3.9,3,4,3.1l3.5,3.5L11,3.1c0.1-0.1,0.3-0.2,0.5-0.2
                  c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5S12,3.9,11.9,4L8.4,7.5L11.9,11z"/>
                  </svg>
                  <span className="h6 font-weight-normal text-reset align-middle">No, Don’t Remove</span>
                </Button>
              </div>
            </ModalBody>
          </Modal>}
      </>
    )
  }
}

const mapStateToProps = (state, props) => {
  const team_id = Number(props.team_id) ? Number(props.team_id) : DEFAULT_SESSION_ID;
  const team_report = getTeamsReportById(state, team_id);
  const team_members_list = getCurrentTeamMembersList(state, props);


  return {
    team_id,
    team_report,
    team_members_list,
    members: team_members_list ? team_members_list.items : new List(),
    displayLoadingIndicator: (team_members_list ? team_members_list.isPending : false) || (team_report ? team_report.isPending : false) || false,
  }
};

const mapDispatchToProps = {
  removeTeamMember: teamActions.removeTeamMember,
  setLeaderTeamMember: teamActions.setLeaderTeamMember,
  loadTeamsReport: teamsReportListActions.loadTeamsReport,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberItem);
